/**
 * Possible address types
 */
export const enum AddressType {
  Delivery = "Delivery",
  Invoice = "Invoice",
}

/**
 * Address search result types
 */
export const enum AddressResultType {
  Org = 0,
  Paf = 1,
}
